export default {
  sm: `
  Knowledge and
  information kept in
  "Chest of Data"
  `,
  lg: `
  Knowledge and information kept in
  "Chest of Data"
  `,
  xxl: `
  Knowledge and information kept in "Chest of Data"
  `
};
